import * as React from 'react';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Avatar, Badge, Typography } from '@mui/material';

import NoUserImage from '@kamernet/assets/no-user-image.webp';
import { OwnerTypeID } from '@kamernet/core/ApiClient/Kamernet';
import { useIntl } from '@kamernet/core/Intl';
import { NavLink } from '@kamernet/core/Routing/NavLink';
import { getImageUrl } from '@kamernet/utilities/Resources/getImageUrl';

import { OwnertypeTranslations } from '@kamernet/modules/Listing/translations';
import { ListingDetailsContext } from '@kamernet/views/ListingDetails/ListingDetailsContext';

import styles from './LandlordProfile.module.css';

export const LandlordProfile = () => {
  const { T } = useIntl();
  const { listingDetails } = ListingDetailsContext.useContext();
  const ownerType = listingDetails.landlordTypeId || OwnerTypeID.Other;

  return (
    <NavLink.Native href="#about-landlord" underline="none">
      <div className={styles.profile}>
        <Badge
          className={styles.badge}
          overlap="circular"
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          badgeContent={
            // eslint-disable-next-line react/jsx-no-useless-fragment
            <React.Fragment>
              {listingDetails.displayVerifiedBadge && (
                <CheckCircleIcon
                  fontSize="medium"
                  color="primary"
                  className={styles.checkIcon}
                />
              )}
            </React.Fragment>
          }
        >
          <Avatar
            alt={listingDetails.landlordDisplayName}
            className={styles.badge}
            src={
              getImageUrl(listingDetails.landlordPhotoKey) || NoUserImage.src
            }
          />
        </Badge>
        <div>
          <Typography variant="subtitle2">
            {listingDetails.landlordDisplayName}
          </Typography>
          <div className={styles.status}>
            <Typography color="secondary.accent" variant="body4">
              {T(OwnertypeTranslations[ownerType])}
            </Typography>
            {listingDetails.displayVerifiedBadge && (
              <React.Fragment>
                <Typography variant="body4">•</Typography>
                <Typography color="secondary.accent" variant="body4">
                  {T('LBL_VERIFIED')}
                </Typography>
              </React.Fragment>
            )}
          </div>
        </div>
      </div>
    </NavLink.Native>
  );
};
